import { render } from "./ListePatient.vue?vue&type=template&id=363cdfb1&scoped=true"
import script from "./ListePatient.vue?vue&type=script&lang=js"
export * from "./ListePatient.vue?vue&type=script&lang=js"

import "./ListePatient.vue?vue&type=style&index=0&id=363cdfb1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363cdfb1"]])

export default __exports__